






































































import { Component, Mixins } from "vue-property-decorator";
import UserManagementBtnMixin from "@/mixins/UserManagementBtnMixin";
import { UpdateUserBodyI } from "@/models/admin/UserModel";
import { ACTION_CHANGE_PASSWORD } from "@/store/actions-types";
import PasswordFormGroup from "@/components/user-management/PasswordFormGroup.vue";
import { PasswordFormGroupModelI } from "@/models/admin/user-management/PasswordFormGroupModelI";
import { UserHelper } from "@/utils/UserHelper";
import { EMIT_NOTIFICATION } from "@/store/mutations-types";
import { NotificationType } from "@/models/NotificationI";
import i18n from "@/plugins/i18n";
import { BValidationState } from "@/models/common/BValidationState";

@Component({
  components: {
    PasswordFormGroup,
  },
})
/**
 * Adds a button and modal with a form to change a user's own password
 */
export default class ChangePasswordBtn extends Mixins(UserManagementBtnMixin) {
  /**
   * The username which will be updated
   * User must provide it as we only know their roles
   */
  public username = "";

  /**
   * the password and it's validation state
   */
  public passwordFormState: PasswordFormGroupModelI = {
    password: "",
    valid: null,
  };

  /**
   * user must provide old password
   */
  public oldPassword = "";

  /**
   * validate username
   */
  get usernameValid(): BValidationState {
    return UserHelper.isValidUsername(this.username);
  }

  /**
   * test old password validity
   */
  get oldPasswordValid(): BValidationState {
    if (this.oldPassword === "" || this.oldPassword === null) return null;

    return !!this.oldPassword;
  }

  /**
   * check if form can be submitted
   */
  get isFormValid(): boolean {
    return !!(
      this.usernameValid &&
      this.passwordFormState.valid &&
      this.oldPasswordValid
    );
  }

  /**
   * update a users password
   */
  async updatePassword(): Promise<void> {
    this.isLoading = true;
    try {
      const user: UpdateUserBodyI = {
        oldPassword: this.oldPassword,
        username: this.username,
        password: this.passwordFormState.password,
      };
      await this.$store.dispatch(ACTION_CHANGE_PASSWORD, user);
      this.modalShow = false;
      this.username = "";
      this.passwordFormState = { password: "", valid: null };
      this.oldPassword = "";
      this.$store.commit(EMIT_NOTIFICATION, {
        type: NotificationType.SUCCESS,
        title: i18n.t("components.ChangePasswordBtn.changeSuccessTitle"),
        text: i18n.t("components.ChangePasswordBtn.changeSuccess"),
      });
    } catch (e) {
      this.$store.commit(EMIT_NOTIFICATION, {
        type: NotificationType.DANGER,
        title: i18n.t("components.ChangePasswordBtn.changeErrorTitle"),
        text: i18n.t("components.ChangePasswordBtn.changeError"),
      });
    } finally {
      this.isLoading = false;
    }
  }
}
